import { App } from "./app";
import * as Sentry from "@sentry/browser";

// Sentry
if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: "https://21d79321ae1ee867d0fa513956450c13@o4508767360319488.ingest.de.sentry.io/4509951723765840",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

window.addEventListener("DOMContentLoaded", () => {
  const app = new App();
  app.start();
});
